export default "__VITE_ASSET__CYQ$cWpG__"